import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const environment = import.meta.env.MODE;

const firebaseConfig =
  environment === "production"
    ? {
        apiKey: "AIzaSyBnAH1V4ELEIV6hYfucZ4fA1PbfdMc9dr4",
        authDomain: "swap-vc-prod.firebaseapp.com",
        projectId: "swap-vc-prod",
        storageBucket: "swap-vc-prod.appspot.com",
        messagingSenderId: "957470233419",
        appId: "1:957470233419:web:f17ff04943d7eb519a0ece",
        measurementId: "G-GK3Z29FFR5",
      }
    : {
        apiKey: "AIzaSyBQBHV8kmBrc_ReztG8bNoT5EaV2c_ZXSA",
        authDomain: "swap-vc.firebaseapp.com",
        databaseURL: "https://swap-vc-default-rtdb.firebaseio.com",
        projectId: "swap-vc",
        storageBucket: "swap-vc.appspot.com",
        messagingSenderId: "836731735529",
        appId: "1:836731735529:web:35d1c2970cc32dcf16cf78",
        measurementId: "G-L7HST07RRL",
      };

const webApp = initializeApp(firebaseConfig, "webApp");
const db = getFirestore(webApp);

export { webApp, db, firebaseConfig };
